import React, { FC, useContext } from 'react';

export interface UserProfile {
  isManager: boolean;
}

const context = React.createContext<{
  userProfile?: UserProfile;
  isLoading: boolean;
  isError: boolean;
}>({
  isLoading: false,
  isError: false,
});

export const UserProfileContext: FC<{ userProfile?: UserProfile }> = ({
  userProfile,
  ...props
}) => {
  const isManager = userProfile?.isManager ?? false;
  const isLoading = false;
  const isError = false;
  return <context.Provider value={{ userProfile: { isManager }, isLoading, isError }} {...props} />;
};

export const useUserProfileContext = () => useContext(context);
